module.exports = __webpack_public_path__ + "img/treehouse.6c14787d.webp";